import { render, staticRenderFns } from "./OtpVerificationModal.vue?vue&type=template&id=2f78596f&scoped=true"
import script from "./OtpVerificationModal.vue?vue&type=script&lang=js"
export * from "./OtpVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./OtpVerificationModal.vue?vue&type=style&index=0&id=2f78596f&prod&lang=css"
import style1 from "./OtpVerificationModal.vue?vue&type=style&index=1&id=2f78596f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78596f",
  null
  
)

export default component.exports